import { videoResources } from "@/mocks/content";

export default function VideoResources() {
  return (
    <section id="videos" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="text-xs md:text-sm font-label font-medium tracking-widest text-accent-700 uppercase">
              Video resources
            </span>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              教学视频资源一览
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 font-body">
              除了逐课目录，系列中还有按阶段打包的连播资源。下表按主题归类整理，
              列出每条资源的时长、清晰度与形式，方便你根据时间安排选择合适的入口。
            </p>
            <div className="mt-6 rounded-lg overflow-hidden border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=clean%20warm%20abstract%20scene%20of%20floating%20video%20screens%20and%20play%20symbols%20in%20amber%20and%20teal%20tones%20on%20cream%20background%2C%20minimal%20editorial%20illustration%20style%2C%20soft%20gradient%20light%2C%20media%20library%20theme&width=1000&height=800&seq=secret-video-wall&orientation=landscape"
                alt="教学视频资源与媒体库示意图"
                className="w-full h-[200px] md:h-[240px] object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg bg-background-50 border border-background-200/70 divide-y divide-background-200/70">
              {videoResources.map((resource) => (
                <div
                  key={resource.id}
                  className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 p-4 md:p-5"
                >
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xl">
                    <i
                      className={
                        resource.format === "图文"
                          ? "ri-article-line"
                          : "ri-play-circle-line"
                      }
                    ></i>
                  </span>

                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 leading-snug">
                      {resource.title}
                    </h3>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600 font-body">
                      {resource.note}
                    </p>
                  </div>

                  <div className="flex items-center gap-2 sm:gap-2.5 shrink-0 flex-wrap">
                    <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-label">
                      {resource.category}
                    </span>
                    <span className="px-2.5 py-1 rounded-full bg-background-200/70 text-foreground-700 text-xs font-label whitespace-nowrap">
                      {resource.duration}
                    </span>
                    <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label whitespace-nowrap">
                      {resource.quality}
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs md:text-sm text-foreground-500 font-body leading-relaxed">
              说明：以上为对系列资源形式的整理归纳，具体可观看内容以官方实际发布为准。
              本页不提供视频文件本身，仅用于目录索引与定位。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}